import axios from "axios";
import { adminServerInstance } from "../axios/instances";
import { getUserPreference } from "../utilities/common";
import { BBC_ORDER_MANAGEMENT as type } from "./bbcOrderManagementTypes";

/**
 * 
 * @param {Object} params
 * @param {string} params.data - Update data
 * @param {string} params.to_state - geteway_out, ready_pickup, picked_up
 * @param {string} params.scan_location - Scan warehouse id
 * @param {string} params.update_type - tnos, bag_nos, sub_batch
 */
export function bbcBoxUpdate(params) {
    return function (dispatch) {
        dispatch({ type: type.BBC_BOX_UPDATE })
        return adminServerInstance.post(`/b2blabel/bbcboxupdatesummary`, params)
            .then(({ data }) => {
                dispatch({
                    type: type.BBC_BOX_UPDATE_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.BBC_BOX_UPDATE_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 * 
 * @param {Object} params
 * @param {number} params.fromTS 
 * @param {number} params.toTS
 */
export function getBbcOrdersByTime(params) {
    return function (dispatch) {
        dispatch({ type: type.GET_BBC_ORDERS_BY_TIME })
        return axios.get(`${process.env.REACT_APP_MAP_SERVER_URL}/b2blabel/getbbcordersbytime`, {
            params,
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${getUserPreference().authToken}`
            },
            timeout: 0
        })
            .then((response) => {
                dispatch({
                    type: type.GET_BBC_ORDERS_BY_TIME_SUCCESS,
                    payload: response
                })
                if (response.headers['content-type'] === "application/json") {
                    return Promise.reject(response);
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Data.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return Promise.resolve(response);
                }
            })
            .catch((error) => {
                dispatch({
                    type: type.GET_BBC_ORDERS_BY_TIME_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}